<!-- src/views/teacher/TeacherDashboard/DivWrapperScreen/sections/HeaderSubsection.vue -->
<template>
	<header class="th-header" role="banner">
		<div class="th-container">
			<!-- Левая часть: логотип -->
			<div class="th-logo">
				<img
					class="th-logo-image"
					alt="Logo"
					src="@/assets/cdn-animaapp/logo.svg"
				/>
			</div>

			<!-- Центральная часть: навигация -->
			<nav class="th-nav" role="navigation">
				<!-- Главная -->
				<router-link
					to="/teacher"
					class="th-nav-link"
					aria-label="Главная страница преподавателя"
				>
					<div class="th-nav-link-content">
						<div class="th-nav-icon-wrapper">
							<svg class="th-nav-icon" viewBox="0 0 24 24" fill="none">
								<path
									d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"
									stroke="currentColor"
									stroke-width="2"
									stroke-linecap="round"
									stroke-linejoin="round"
								/>
								<path
									d="M9 22V12h6v10"
									stroke="currentColor"
									stroke-width="2"
									stroke-linecap="round"
									stroke-linejoin="round"
								/>
							</svg>
						</div>
						<span class="th-nav-label">Главная</span>
					</div>
					<div class="th-nav-link-indicator"></div>
				</router-link>

				<!-- Сообщения -->
				<!-- <button
					type="button"
					class="th-nav-btn"
					@click="handleMessages"
					:class="{ 'th-nav-btn--active': safeMessagesCount > 0 }"
					:aria-label="`Сообщения${
						safeMessagesCount > 0 ? ` (${safeMessagesCount} новых)` : ''
					}`"
				>
					<div class="th-nav-btn-content">
						<div class="th-nav-icon-wrapper">
							<svg class="th-nav-icon" viewBox="0 0 24 24" fill="none">
								<path
									d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"
									stroke="currentColor"
									stroke-width="2"
									stroke-linecap="round"
									stroke-linejoin="round"
								/>
							</svg>
							<transition name="badge-pop">
								<span
									v-if="safeMessagesCount > 0"
									class="th-badge th-badge--primary"
								>
									{{ messagesBadge }}
								</span>
							</transition>
						</div>
						<span class="th-nav-label">Сообщения</span>
					</div>
				</button> -->

				<!-- Уведомления -->
				<div class="th-notifications" ref="notificationsContainer">
					<button
						type="button"
						class="th-nav-btn"
						@click="handleNotifications"
						:class="{ 'th-nav-btn--active': safeNotificationsCount > 0 }"
						:aria-label="`Уведомления${
							safeNotificationsCount > 0
								? ` (${safeNotificationsCount} новых)`
								: ''
						}`"
						:aria-expanded="notificationsOpen"
					>
						<div class="th-nav-btn-content">
							<div class="th-nav-icon-wrapper">
								<svg class="th-nav-icon" viewBox="0 0 24 24" fill="none">
									<path
										d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9"
										stroke="currentColor"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
									/>
									<path
										d="M13.73 21a2 2 0 01-3.46 0"
										stroke="currentColor"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
									/>
								</svg>
								<transition name="badge-pop">
									<span
										v-if="safeNotificationsCount > 0"
										class="th-badge th-badge--danger"
									>
										{{ notificationsBadge }}
									</span>
								</transition>
							</div>
							<span class="th-nav-label">Уведомления</span>
						</div>
					</button>

					<transition name="th-notifications-dropdown">
						<div
							v-if="notificationsOpen"
							class="th-notifications-dropdown"
							@mousedown.prevent
						>
							<div class="th-notifications-header">
								<span>Уведомления</span>
								<button
									v-if="notificationsList.length"
									type="button"
									class="th-notifications-clear"
									@click="clearNotifications"
								>
									Очистить
								</button>
							</div>

							<div v-if="notificationsLoading" class="th-notifications-empty">
								Загрузка...
							</div>
							<div
								v-else-if="notificationsError"
								class="th-notifications-empty"
							>
								{{ notificationsError }}
							</div>
							<div
								v-else-if="!notificationsList.length"
								class="th-notifications-empty"
							>
								Новых уведомлений нет.
							</div>
							<ul v-else class="th-notifications-list">
								<li
									v-for="item in notificationsList"
									:key="item.id"
									class="th-notifications-item"
								>
									<div class="th-notifications-item-title">
										{{ item.title || 'Уведомление' }}
									</div>
									<div class="th-notifications-item-text">
										{{ item.message }}
									</div>
									<div class="th-notifications-item-time">
										{{ formatNotificationTime(item.timestamp) }}
									</div>
									<button
										type="button"
										class="th-notifications-close"
										aria-label="Удалить уведомление"
										@click.stop="removeNotification(item.id)"
									>
										<svg viewBox="0 0 24 24" fill="none">
											<path
												d="M18 6L6 18M6 6l12 12"
												stroke="currentColor"
												stroke-width="2"
												stroke-linecap="round"
											/>
										</svg>
									</button>
								</li>
							</ul>
						</div>
					</transition>
				</div>
			</nav>

			<!-- Разделитель -->
			<div class="th-divider"></div>

			<!-- Правая часть: поиск и профиль -->
			<div class="th-actions">
				<!-- Поиск с автодополнением -->
				<template v-if="false">
					<div
						class="th-search"
						:class="{ 'th-search--active': searchFocused || searchQuery }"
						ref="searchContainer"
					>
						<!-- Поле поиска -->
						<div class="th-search-field">
							<input
								ref="searchInput"
								v-model="searchQuery"
								type="text"
								class="th-search-input"
								:placeholder="searchPlaceholder"
								:maxlength="maxSearchLength"
								@focus="handleSearchFocus"
								@blur="handleSearchBlur"
								@input="handleSearchInput"
								@keydown="handleSearchKeydown"
								:aria-expanded="showSearchDropdown"
								aria-autocomplete="list"
								aria-controls="search-results"
								autocomplete="off"
							/>

							<!-- Кнопка очистки -->
							<button
								v-if="searchQuery"
								type="button"
								class="th-search-clear"
								@click="clearSearch"
								aria-label="Очистить поиск"
							>
								<svg width="14" height="14" viewBox="0 0 24 24" fill="none">
									<path
										d="M18 6L6 18M6 6l12 12"
										stroke="currentColor"
										stroke-width="2"
										stroke-linecap="round"
									/>
								</svg>
							</button>

							<!-- Кнопка поиска -->
							<button
								type="button"
								class="th-search-btn"
								@click="executeSearch"
								:class="{ 'th-search-btn--active': searchQuery }"
								:disabled="!isSearchValid"
								aria-label="Выполнить поиск"
							>
								<svg v-if="!isSearching" viewBox="0 0 24 24" fill="none">
									<circle
										cx="11"
										cy="11"
										r="8"
										stroke="currentColor"
										stroke-width="2"
									/>
									<path
										d="M21 21l-4.35-4.35"
										stroke="currentColor"
										stroke-width="2"
										stroke-linecap="round"
									/>
								</svg>
								<!-- Индикатор загрузки -->
								<div v-else class="th-search-spinner">
									<svg viewBox="0 0 24 24" fill="none">
										<circle
											cx="12"
											cy="12"
											r="10"
											stroke="currentColor"
											stroke-width="2"
											opacity="0.25"
										/>
										<path
											d="M12 2a10 10 0 010 20"
											stroke="currentColor"
											stroke-width="2"
											stroke-linecap="round"
										/>
									</svg>
								</div>
							</button>
						</div>

						<!-- Dropdown с результатами -->
						<transition name="search-dropdown">
							<div
								v-if="showSearchDropdown"
								id="search-results"
								class="th-search-dropdown"
								@mousedown.prevent
							>
								<!-- Быстрый доступ для преподавателя -->
								<div
									v-if="!searchQuery && !searchResults.length"
									class="th-search-quick"
								>
									<div class="th-search-section-title">Быстрый доступ</div>
									<div class="th-search-tags">
										<button
											v-for="tag in teacherQuickAccess"
											:key="tag.id"
											type="button"
											class="th-search-tag"
											@click="navigateToQuickAccess(tag)"
										>
											<component :is="tag.icon" class="th-search-tag-icon" />
											{{ tag.label }}
										</button>
									</div>

									<!-- История поиска -->
									<div
										v-if="searchHistory.length > 0"
										class="th-search-history"
									>
										<div class="th-search-section-header">
											<span class="th-search-section-title"
												>Недавние поиски</span
											>
											<button
												type="button"
												class="th-search-clear-history"
												@click="clearSearchHistory"
											>
												Очистить
											</button>
										</div>
										<button
											v-for="(item, index) in searchHistory"
											:key="`history-${index}`"
											type="button"
											class="th-search-history-item"
											@click="selectFromHistory(item)"
										>
											<svg
												width="14"
												height="14"
												viewBox="0 0 24 24"
												fill="none"
											>
												<circle
													cx="12"
													cy="12"
													r="10"
													stroke="currentColor"
													stroke-width="2"
												/>
												<path
													d="M12 6v6l4 2"
													stroke="currentColor"
													stroke-width="2"
													stroke-linecap="round"
												/>
											</svg>
											<span>{{ sanitizeText(item) }}</span>
										</button>
									</div>
								</div>

								<!-- Результаты поиска -->
								<div v-else-if="isSearching" class="th-search-loading">
									<div class="th-search-loading-spinner"></div>
									<span>Поиск...</span>
								</div>

								<div
									v-else-if="searchResults.length > 0"
									class="th-search-results"
								>
									<!-- Мои курсы -->
									<div
										v-if="myCourseResults.length > 0"
										class="th-search-category"
									>
										<div class="th-search-category-header">
											<span class="th-search-category-title">Мои курсы</span>
											<span class="th-search-category-count">{{
												myCourseResults.length
											}}</span>
										</div>
										<router-link
											v-for="course in myCourseResults.slice(0, 3)"
											:key="`course-${course.id}`"
											:to="`/teacher/course/${course.id}/edit`"
											class="th-search-result"
											@click="selectResult(course)"
										>
											<div
												class="th-search-result-icon th-search-result-icon--course"
											>
												<svg
													width="16"
													height="16"
													viewBox="0 0 24 24"
													fill="none"
												>
													<path
														d="M4 19.5A2.5 2.5 0 016.5 17H20"
														stroke="currentColor"
														stroke-width="2"
														stroke-linecap="round"
													/>
													<path
														d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z"
														stroke="currentColor"
														stroke-width="2"
													/>
												</svg>
											</div>
											<div class="th-search-result-content">
												<div
													class="th-search-result-title"
													v-html="highlightMatch(course.title)"
												></div>
												<div class="th-search-result-meta">
													{{ course.studentsCount }} студентов ·
													{{ course.status }}
												</div>
											</div>
											<div
												v-if="course.isDraft"
												class="th-search-result-badge th-search-result-badge--draft"
											>
												Черновик
											</div>
										</router-link>
									</div>

									<!-- Студенты -->
									<div
										v-if="studentResults.length > 0"
										class="th-search-category"
									>
										<div class="th-search-category-header">
											<span class="th-search-category-title">Студенты</span>
											<span class="th-search-category-count">{{
												studentResults.length
											}}</span>
										</div>
										<router-link
											v-for="student in studentResults.slice(0, 3)"
											:key="`student-${student.id}`"
											:to="`/teacher/student/${student.id}`"
											class="th-search-result"
											@click="selectResult(student)"
										>
											<div
												class="th-search-result-icon th-search-result-icon--student"
											>
												<svg
													width="16"
													height="16"
													viewBox="0 0 24 24"
													fill="none"
												>
													<circle
														cx="12"
														cy="8"
														r="4"
														stroke="currentColor"
														stroke-width="2"
													/>
													<path
														d="M6 21v-2a4 4 0 014-4h4a4 4 0 014 4v2"
														stroke="currentColor"
														stroke-width="2"
													/>
												</svg>
											</div>
											<div class="th-search-result-content">
												<div
													class="th-search-result-title"
													v-html="highlightMatch(student.name)"
												></div>
												<div class="th-search-result-meta">
													{{ student.courses }} курсов · {{ student.progress }}%
													прогресс
												</div>
											</div>
										</router-link>
									</div>

									<!-- Показать все результаты -->
									<button
										v-if="totalResults > 6"
										type="button"
										class="th-search-show-all"
										@click="showAllResults"
									>
										Показать все результаты ({{ totalResults }})
										<svg width="14" height="14" viewBox="0 0 24 24" fill="none">
											<path
												d="M9 18l6-6-6-6"
												stroke="currentColor"
												stroke-width="2"
												stroke-linecap="round"
											/>
										</svg>
									</button>
								</div>

								<!-- Нет результатов -->
								<div
									v-else-if="searchQuery && !isSearching"
									class="th-search-empty"
								>
									<svg width="48" height="48" viewBox="0 0 24 24" fill="none">
										<circle
											cx="11"
											cy="11"
											r="8"
											stroke="currentColor"
											stroke-width="2"
											opacity="0.25"
										/>
										<path
											d="M21 21l-4.35-4.35"
											stroke="currentColor"
											stroke-width="2"
											stroke-linecap="round"
											opacity="0.25"
										/>
									</svg>
									<p class="th-search-empty-title">Ничего не найдено</p>
									<p class="th-search-empty-text">Попробуйте изменить запрос</p>
								</div>
							</div>
						</transition>
					</div>
				</template>

				<!-- Профиль с dropdown -->
				<div class="th-profile" ref="profileContainer">
					<button
						ref="dropdownTrigger"
						type="button"
						class="th-profile-btn"
						@click="toggleDropdown"
						:aria-expanded="isOpen"
					>
						<div class="th-profile-avatar">
							<div class="th-profile-avatar-clip">
								<img
									v-if="safeAvatarUrl"
									:src="safeAvatarUrl"
									:alt="`Аватар пользователя`"
									class="th-profile-avatar-img"
									@error="handleAvatarError"
									referrerpolicy="no-referrer"
									crossorigin="anonymous"
								/>
								<div v-else class="th-profile-avatar-placeholder">
									{{ safeUserInitials }}
								</div>
							</div>
							<div class="th-profile-status th-profile-status--online"></div>
						</div>

						<div class="th-profile-info">
							<span class="th-profile-name">{{ safeUserName }}</span>
							<span class="th-profile-role">
								<svg
									class="th-profile-role-icon"
									viewBox="0 0 24 24"
									fill="none"
								>
									<path
										d="M12 14l9-5-9-5-9 5z"
										stroke="currentColor"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
									/>
									<path
										d="M12 14l9-5v7l-9 5-9-5v-7z"
										stroke="currentColor"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
									/>
								</svg>
								Преподаватель
							</span>
						</div>
						<svg
							class="th-profile-arrow"
							:class="{ 'th-profile-arrow--open': isOpen }"
							viewBox="0 0 24 24"
							fill="none"
						>
							<path
								d="M6 9l6 6 6-6"
								stroke="currentColor"
								stroke-width="2"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
						</svg>
					</button>

					<!-- Dropdown меню -->
					<transition name="th-dropdown">
						<div v-if="isOpen" class="th-dropdown" role="menu" @click.stop>
							<!-- Краткий header в dropdown -->
							<div class="th-dropdown-header">
								<div class="th-dropdown-avatar">
									<img
										v-if="safeAvatarUrl"
										:src="safeAvatarUrl"
										alt=""
										@error="handleAvatarError"
										referrerpolicy="no-referrer"
										crossorigin="anonymous"
									/>
									<div v-else class="th-dropdown-avatar-placeholder">
										{{ safeUserInitials }}
									</div>
								</div>
								<div class="th-dropdown-user">
									<div class="th-dropdown-username">{{ safeUserName }}</div>
									<div class="th-dropdown-email">{{ maskedEmail }}</div>
								</div>
							</div>

							<div class="th-dropdown-divider"></div>

							<!-- Пункты меню -->
							<router-link
								to="/teacher/profile"
								class="th-dropdown-item"
								@click="closeDropdown"
							>
								<svg class="th-dropdown-icon" viewBox="0 0 24 24" fill="none">
									<path
										d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"
										stroke="currentColor"
										stroke-width="2"
										stroke-linecap="round"
									/>
									<circle
										cx="12"
										cy="7"
										r="4"
										stroke="currentColor"
										stroke-width="2"
									/>
								</svg>
								<span>Мой профиль</span>
							</router-link>

							<router-link
								to="/teacher/settings"
								class="th-dropdown-item"
								@click="closeDropdown"
							>
								<svg class="th-dropdown-icon" viewBox="0 0 16 16" fill="none">
									<path
										d="M15.2 6l-1.1-0.2c-0.1-0.2-0.1-0.4-0.2-0.6l0.6-0.9 0.5-0.7-2.6-2.6-0.7 0.5-0.9 0.6c-0.2-0.1-0.4-0.1-0.6-0.2l-0.2-1.1-0.2-0.8h-3.6l-0.2 0.8-0.2 1.1c-0.2 0.1-0.4 0.1-0.6 0.2l-0.9-0.6-0.7-0.4-2.5 2.5 0.5 0.7 0.6 0.9c-0.2 0.2-0.2 0.4-0.3 0.6l-1.1 0.2-0.8 0.2v3.6l0.8 0.2 1.1 0.2c0.1 0.2 0.1 0.4 0.2 0.6l-0.6 0.9-0.5 0.7 2.6 2.6 0.7-0.5 0.9-0.6c0.2 0.1 0.4 0.1 0.6 0.2l0.2 1.1 0.2 0.8h3.6l0.2-0.8 0.2-1.1c0.2-0.1 0.4-0.1 0.6-0.2l0.9 0.6 0.7 0.5 2.6-2.6-0.5-0.7-0.6-0.9c0.1-0.2 0.2-0.4 0.2-0.6l1.1-0.2 0.8-0.2v-3.6l-0.8-0.2zM15 9l-1.7 0.3c-0.1 0.5-0.3 1-0.6 1.5l0.9 1.4-1.4 1.4-1.4-0.9c-0.5 0.3-1 0.5-1.5 0.6l-0.3 1.7h-2l-0.3-1.7c-0.5-0.1-1-0.3-1.5-0.6l-1.4 0.9-1.4-1.4 0.9-1.4c-0.3-0.5-0.5-1-0.6-1.5l-1.7-0.3v-2l1.7-0.3c0.1-0.5 0.3-1 0.6-1.5l-1-1.4 1.4-1.4 1.4 0.9c0.5-0.3 1-0.5 1.5-0.6l0.4-1.7h2l0.3 1.7c0.5 0.1 1 0.3 1.5 0.6l1.4-0.9 1.4 1.4-0.9 1.4c0.3 0.5 0.5 1 0.6 1.5l1.7 0.3v2z"
										fill="currentColor"
									/>
									<path
										d="M8 4.5c-1.9 0-3.5 1.6-3.5 3.5s1.6 3.5 3.5 3.5 3.5-1.6 3.5-3.5c0-1.9-1.6-3.5-3.5-3.5zM8 10.5c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5c0 1.4-1.1 2.5-2.5 2.5z"
										fill="currentColor"
									/>
								</svg>
								<span>Настройки</span>
							</router-link>

							<div class="th-dropdown-divider"></div>

							<router-link
								to="/help"
								class="th-dropdown-item"
								@click="closeDropdown"
							>
								<svg class="th-dropdown-icon" viewBox="0 0 24 24" fill="none">
									<circle
										cx="12"
										cy="12"
										r="10"
										stroke="currentColor"
										stroke-width="2"
									/>
									<path
										d="M9.09 9a3 3 0 015.83 1c0 2-3 3-3 3"
										stroke="currentColor"
										stroke-width="2"
										stroke-linecap="round"
									/>
									<circle cx="12" cy="17" r="0.5" fill="currentColor" />
								</svg>
								<span>Помощь</span>
							</router-link>

							<div class="th-dropdown-divider"></div>

							<button
								type="button"
								class="th-dropdown-item th-dropdown-item--danger"
								@click="handleLogout"
								:disabled="isLoggingOut"
							>
								<svg class="th-dropdown-icon" viewBox="0 0 24 24" fill="none">
									<path
										d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9"
										stroke="currentColor"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
									/>
								</svg>
								<span>{{ isLoggingOut ? 'Выход...' : 'Выйти' }}</span>
							</button>
						</div>
					</transition>
				</div>
			</div>
		</div>
	</header>
</template>

<script>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
import { useRouter } from 'vue-router'
import { debounce } from 'lodash-es'
import DOMPurify from 'dompurify'
import { useAppStore } from '@/stores/useAppStore'
import { api } from '@/services'
import accountSocket from '@/services/accountSocket'
import { searchService } from '@/services/teacherSearchService'

// Утилиты безопасности
const SecurityUtils = {
	sanitizeText(text) {
		if (!text) return ''
		return DOMPurify.sanitize(text, { ALLOWED_TAGS: [] })
	},

	isValidImageUrl(url) {
		if (!url) return false
		if (url.startsWith('/')) return true
		try {
			const urlObj = new URL(url)
			if (!['https:', 'http:', 'data:'].includes(urlObj.protocol)) {
				return false
			}
			return true
		} catch {
			return false
		}
	},

	maskEmail(email) {
		if (!email || !email.includes('@')) return '***@***.***'
		const [local, domain] = email.split('@')
		const maskedLocal =
			local.length > 2
				? local[0] +
				  '*'.repeat(Math.max(local.length - 2, 3)) +
				  local[local.length - 1]
				: '*'.repeat(local.length)
		const [domainName, ...domainExt] = domain.split('.')
		const maskedDomain =
			domainName[0] + '*'.repeat(Math.max(domainName.length - 1, 3))
		return `${maskedLocal}@${maskedDomain}.${domainExt.join('.')}`
	},

	isValidSearchQuery(query) {
		if (!query) return false
		const dangerousPatterns = [
			/<script/i,
			/javascript:/i,
			/on\w+\s*=/i,
			/SELECT.*FROM/i,
			/DROP\s+TABLE/i,
			/INSERT\s+INTO/i,
			/DELETE\s+FROM/i,
			/UPDATE.*SET/i,
			/--/,
			/\/\*/,
			/\*\//,
			/<iframe/i,
			/<object/i,
			/<embed/i,
		]
		return !dangerousPatterns.some(pattern => pattern.test(query))
	},

	createRateLimiter(maxAttempts = 5, windowMs = 60000) {
		const attempts = new Map()

		return function (key) {
			const now = Date.now()
			const userAttempts = attempts.get(key) || []
			const recentAttempts = userAttempts.filter(time => now - time < windowMs)

			if (recentAttempts.length >= maxAttempts) {
				return false
			}

			recentAttempts.push(now)
			attempts.set(key, recentAttempts)
			return true
		}
	},
}

const NOTIFICATIONS_ENDPOINT =
	import.meta.env?.VITE_NOTIFICATIONS_ENDPOINT ||
	process.env.VUE_APP_NOTIFICATIONS_ENDPOINT ||
	'/notifications'
const NOTIFICATIONS_COUNT_ENDPOINT = `${NOTIFICATIONS_ENDPOINT}/unread-count`
const NOTIFICATIONS_READ_ALL_ENDPOINT = `${NOTIFICATIONS_ENDPOINT}/read-all`

export default {
	name: 'TeacherHeader',

	props: {
		messagesCount: {
			type: Number,
			default: 0,
			validator: value => value >= 0 && value <= 9999,
		},
		notificationsCount: {
			type: Number,
			default: 0,
			validator: value => value >= 0 && value <= 9999,
		},
		maxSearchLength: {
			type: Number,
			default: 100,
		},
		searchPlaceholder: {
			type: String,
			default: 'Поиск курсов, студентов...',
			validator: value => value.length <= 50,
		},
		logoAlt: {
			type: String,
			default: 'Логотип академии',
		},
	},

	emits: ['search', 'open-messages', 'open-notifications', 'logout'],

	setup(props, { emit }) {
		const router = useRouter()
		const appStore = useAppStore()

		// Rate limiters
		const searchRateLimiter = SecurityUtils.createRateLimiter(10, 60000)
		const logoutRateLimiter = SecurityUtils.createRateLimiter(3, 60000)

		// State
		const searchQuery = ref('')
		const searchFocused = ref(false)
		const showSearchDropdown = ref(false)
		const isSearching = ref(false)
		const searchResults = ref([])
		const searchHistory = ref([])
		const selectedIndex = ref(-1)

		const isOpen = ref(false)
		const isLoggingOut = ref(false)
		const avatarError = ref(false)
		const notificationsOpen = ref(false)
		const notificationsContainer = ref(null)
		const notificationsLoading = ref(false)
		const notificationsError = ref('')
		const notificationsListApi = ref([])
		const notificationsApiAvailable = ref(true)
		const hasFetchedNotifications = ref(false)
		const unreadCount = ref(null)
		let notificationsPoller = null
		let notificationUnsubscribe = null

		const searchContainer = ref(null)
		const searchInput = ref(null)
		const profileContainer = ref(null)
		const dropdownTrigger = ref(null)

		// Teacher specific - загрузка базовой статистики
		const teacherStats = ref({
			courses: 0,
			students: 0,
		})
		const hasAccessToken = () => {
			if (typeof window === 'undefined') return false
			return !!localStorage.getItem('access_token')
		}

		const loadTeacherStats = async () => {
			if (!hasAccessToken()) {
				teacherStats.value = { courses: 0, students: 0 }
				return
			}
			try {
				const stats = await searchService.getTeacherStats()
				teacherStats.value = stats
			} catch (error) {
				console.error('[TeacherHeader] Failed to load stats:', error)
			}
		}

		const teacherQuickAccess = ref([
			{
				id: 'new-course',
				label: 'Создать курс',
				path: '/teacher/course/create',
				icon: 'PlusIcon',
			},
			{
				id: 'students',
				label: 'Студенты',
				path: '/teacher/students',
				icon: 'UsersIcon',
			},
			{
				id: 'analytics',
				label: 'Аналитика',
				path: '/teacher/analytics',
				icon: 'ChartIcon',
			},
			{
				id: 'schedule',
				label: 'Расписание',
				path: '/teacher/schedule',
				icon: 'CalendarIcon',
			},
		])

		// Нормализация computed
		const normalizeNotification = (item, index = 0) => {
			const raw = item || {}
			const id =
				raw.id || raw._id || raw.notificationId || raw.uuid || `local-${index}`
			const title = raw.title || raw.subject || raw.name || ''
			const message =
				raw.message || raw.text || raw.body || raw.description || ''
			const timestamp =
				raw.timestamp ||
				raw.createdAt ||
				raw.created_at ||
				raw.time ||
				Date.now()
			const read = Boolean(
				raw.read || raw.isRead || raw.readAt || raw.read_at || raw.seenAt,
			)
			const type = raw.type || raw.category || 'info'
			return { id, title, message, timestamp, read, type }
		}

		const safeMessagesCount = computed(() => {
			const count = parseInt(props.messagesCount) || 0
			return Math.min(Math.max(0, count), 9999)
		})

		const safeNotificationsCount = computed(() => {
			const countFromProps = parseInt(props.notificationsCount) || 0
			if (typeof unreadCount.value === 'number') {
				return Math.min(Math.max(0, unreadCount.value), 9999)
			}
			const storeCount = notificationsList.value.length
			const count = countFromProps || storeCount
			return Math.min(Math.max(0, count), 9999)
		})

		const notificationsList = computed(() => {
			if (notificationsApiAvailable.value && hasFetchedNotifications.value) {
				return notificationsListApi.value
			}
			const list = Array.isArray(appStore.notifications?.value)
				? appStore.notifications.value
				: Array.isArray(appStore.notifications)
				? appStore.notifications
				: []
			return list
				.filter(item => (item?.channel || 'toast') === 'inbox')
				.map((item, index) => normalizeNotification(item, index))
				.sort((a, b) => (b?.timestamp || 0) - (a?.timestamp || 0))
		})
		const safeUserName = computed(() => {
			const user = appStore.currentUser
			if (!user) return 'Преподаватель'

			const fullName = user.fullName || user.full_name || ''
			const sanitized = SecurityUtils.sanitizeText(fullName)

			if (!sanitized) {
				return 'Преподаватель'
			}

			const parts = sanitized.trim().split(/\s+/)
			if (parts.length >= 2) {
				return `${parts[0]} ${parts[1]}`.substring(0, 50)
			}

			return sanitized.substring(0, 50)
		})

		const maskedEmail = computed(() => {
			const user = appStore.currentUser
			const email = user?.email || 'teacher@academy.ru'
			return SecurityUtils.maskEmail(email)
		})

		const safeAvatarUrl = computed(() => {
			if (avatarError.value) return null

			const user = appStore.currentUser
			const url = user?.avatar || user?.avatarUrl || user?.avatar_url

			if (!url) return null

			if (!SecurityUtils.isValidImageUrl(url)) {
				console.warn('[Security] Invalid avatar URL blocked')
				return null
			}

			return url
		})

		const safeLogoUrl = computed(() => {
			const defaultUrl =
				'/assets/animaapp/logo.svg'
			return SecurityUtils.isValidImageUrl(defaultUrl)
				? defaultUrl
				: '/logo.png'
		})

		const safeUserInitials = computed(() => {
			const name = safeUserName.value
			const parts = name.split(' ').filter(Boolean)

			if (parts.length >= 2) {
				return `${parts[0][0]}${parts[1][0]}`.toUpperCase()
			}

			return name.substring(0, 2).toUpperCase()
		})

		const messagesBadge = computed(() => {
			const count = safeMessagesCount.value
			if (count <= 0) return ''
			return count > 99 ? '99+' : String(count)
		})

		const notificationsBadge = computed(() => {
			const count = safeNotificationsCount.value
			if (count <= 0) return ''
			return count > 99 ? '99+' : String(count)
		})

		const formatNotificationTime = timestamp => {
			if (!timestamp) return ''
			const date = new Date(timestamp)
			if (Number.isNaN(date.getTime())) return ''
			return date.toLocaleString('ru-RU', {
				day: '2-digit',
				month: '2-digit',
				year: '2-digit',
				hour: '2-digit',
				minute: '2-digit',
			})
		}

		const setNotificationsFromApi = payload => {
			const list = Array.isArray(payload?.notifications)
				? payload.notifications
				: Array.isArray(payload)
				? payload
				: []
			notificationsListApi.value = list.map((item, index) =>
				normalizeNotification(item, index),
			)
			hasFetchedNotifications.value = true
			if (typeof payload?.unreadCount === 'number') {
				unreadCount.value = payload.unreadCount
			}
		}

		const addIncomingNotification = payload => {
			const incoming = normalizeNotification(payload, 0)
			if (!incoming?.id) return
			const exists = notificationsListApi.value.some(
				item => String(item.id) === String(incoming.id),
			)
			if (!exists) {
				notificationsListApi.value = [incoming, ...notificationsListApi.value]
			}
			hasFetchedNotifications.value = true
			notificationsApiAvailable.value = true
			if (typeof unreadCount.value === 'number') {
				unreadCount.value = unreadCount.value + 1
			} else {
				unreadCount.value = notificationsListApi.value.length
			}
		}

		const fetchUnreadCount = async () => {
			if (!notificationsApiAvailable.value || !hasAccessToken()) return
			try {
				const response = await api.get(NOTIFICATIONS_COUNT_ENDPOINT)
				const payload = response?.data?.data || response?.data || {}
				if (typeof payload?.unreadCount === 'number') {
					unreadCount.value = payload.unreadCount
				}
			} catch (error) {
				notificationsApiAvailable.value = false
				console.warn('[TeacherHeader] Notifications count unavailable:', error)
			}
		}

		const fetchNotifications = async () => {
			if (!notificationsApiAvailable.value || !hasAccessToken()) return
			notificationsLoading.value = true
			notificationsError.value = ''
			try {
				const response = await api.get(NOTIFICATIONS_ENDPOINT, {
					params: { limit: 50, unreadOnly: true },
				})
				const payload = response?.data?.data || response?.data || {}
				setNotificationsFromApi(payload)
				if (typeof payload?.unreadCount === 'number') {
					unreadCount.value = payload.unreadCount
				}
			} catch (error) {
				notificationsApiAvailable.value = false
				notificationsError.value =
					error?.message || 'Не удалось загрузить уведомления'
				console.warn('[TeacherHeader] Notifications unavailable:', error)
			} finally {
				notificationsLoading.value = false
			}
		}

		const startNotificationsPolling = () => {
			if (notificationsPoller || !hasAccessToken()) return
			notificationsPoller = setInterval(() => {
				if (!notificationsApiAvailable.value || !hasAccessToken()) return
				fetchUnreadCount()
			}, 45000)
		}

		const stopNotificationsPolling = () => {
			if (notificationsPoller) {
				clearInterval(notificationsPoller)
				notificationsPoller = null
			}
		}
		const isSearchValid = computed(() => {
			const query = searchQuery.value.trim()
			return (
				query.length > 0 &&
				query.length <= props.maxSearchLength &&
				SecurityUtils.isValidSearchQuery(query)
			)
		})

		const myCourseResults = computed(() =>
			searchResults.value.filter(r => r.type === 'course'),
		)

		const studentResults = computed(() =>
			searchResults.value.filter(r => r.type === 'student'),
		)

		const totalResults = computed(() => searchResults.value.length)

		// Утилиты
		const sanitizeText = text => SecurityUtils.sanitizeText(text)

		const highlightMatch = text => {
			if (!searchQuery.value) return text
			const sanitizedText = SecurityUtils.sanitizeText(text)
			const regex = new RegExp(`(${searchQuery.value})`, 'gi')
			return sanitizedText.replace(regex, '<mark>$1</mark>')
		}

		const loadSearchHistory = () => {
			try {
				const history = localStorage.getItem('teacherSearchHistory')
				if (history) {
					searchHistory.value = JSON.parse(history).slice(0, 5)
				}
			} catch (error) {
				console.error('Failed to load search history:', error)
			}
		}

		const saveToHistory = query => {
			if (!query || query.length < 2) return

			const sanitized = SecurityUtils.sanitizeText(query)
			const filtered = searchHistory.value.filter(item => item !== sanitized)
			searchHistory.value = [sanitized, ...filtered].slice(0, 5)

			try {
				localStorage.setItem(
					'teacherSearchHistory',
					JSON.stringify(searchHistory.value),
				)
			} catch (error) {
				console.error('Failed to save search history:', error)
			}
		}

		const clearSearchHistory = () => {
			searchHistory.value = []
			localStorage.removeItem('teacherSearchHistory')
		}

		// Поиск с debounce - защита сервера поиска
		const performSearch = debounce(async query => {
			if (!query || query.length < 2) {
				searchResults.value = []
				isSearching.value = false
				return
			}

			isSearching.value = true

			try {
				const sanitizedQuery = SecurityUtils.sanitizeText(query)
				const results = await searchService.search(sanitizedQuery)

				searchResults.value = results
			} catch (error) {
				console.error('[TeacherHeader] Search error:', error)
				searchResults.value = []
			} finally {
				isSearching.value = false
			}
		}, 300)

		const handleSearchFocus = () => {
			searchFocused.value = true
			showSearchDropdown.value = true
			loadSearchHistory()
		}

		const handleSearchBlur = () => {
			searchFocused.value = false
			setTimeout(() => {
				if (!searchContainer.value?.contains(document.activeElement)) {
					showSearchDropdown.value = false
				}
			}, 200)
		}

		const handleSearchInput = () => {
			const cleaned = searchQuery.value
				.replace(/[<>'"]/g, '')
				.substring(0, props.maxSearchLength)

			if (cleaned !== searchQuery.value) {
				searchQuery.value = cleaned
			}

			selectedIndex.value = -1
			if (searchQuery.value.length >= 2) {
				performSearch(searchQuery.value)
			} else {
				searchResults.value = []
			}
		}

		const handleSearchKeydown = event => {
			const resultsCount = searchResults.value.length

			switch (event.key) {
				case 'ArrowDown':
					event.preventDefault()
					if (selectedIndex.value < resultsCount - 1) {
						selectedIndex.value++
					} else {
						selectedIndex.value = 0
					}
					break

				case 'ArrowUp':
					event.preventDefault()
					if (selectedIndex.value > 0) {
						selectedIndex.value--
					} else {
						selectedIndex.value = resultsCount - 1
					}
					break

				case 'Enter':
					event.preventDefault()
					if (selectedIndex.value >= 0) {
						const selected = searchResults.value[selectedIndex.value]
						selectResult(selected)
					} else {
						executeSearch()
					}
					break

				case 'Escape':
					event.preventDefault()
					clearSearch()
					showSearchDropdown.value = false
					searchInput.value?.blur()
					break
			}
		}

		const executeSearch = () => {
			if (!isSearchValid.value) {
				appStore.showWarning('Недопустимые символы запроса')
				return
			}

			if (!searchRateLimiter('search')) {
				appStore.showWarning('Слишком много запросов. Подождите немного')
				return
			}

			const sanitizedQuery = SecurityUtils.sanitizeText(
				searchQuery.value.trim(),
			)
			saveToHistory(sanitizedQuery)
			emit('search', sanitizedQuery)

			router.push({
				path: '/teacher/search',
				query: { q: sanitizedQuery },
			})

			showSearchDropdown.value = false
		}

		const selectResult = result => {
			saveToHistory(searchQuery.value)
			showSearchDropdown.value = false

			if (result.type === 'course') {
				router.push(`/teacher/course/${result.id}/edit`)
			} else if (result.type === 'student') {
				router.push(`/teacher/student/${result.id}`)
			}
		}

		const selectFromHistory = item => {
			searchQuery.value = item
			performSearch(item)
		}

		const navigateToQuickAccess = item => {
			router.push(item.path)
			showSearchDropdown.value = false
		}

		const clearSearch = () => {
			searchQuery.value = ''
			searchResults.value = []
			selectedIndex.value = -1
		}

		const showAllResults = () => {
			executeSearch()
		}

		// Уведомления функции
		const clearNotifications = async () => {
			if (notificationsApiAvailable.value) {
				try {
					await api.post(NOTIFICATIONS_READ_ALL_ENDPOINT)
					notificationsListApi.value = []
					if (typeof unreadCount.value === 'number') {
						unreadCount.value = 0
					}
				} catch (error) {
					console.warn('[TeacherHeader] Failed to clear notifications:', error)
				}
			}
			appStore.clearNotifications('inbox')
			notificationsOpen.value = false
		}

		const removeNotification = async id => {
			const idValue = String(id || '')
			if (!idValue) return
			if (notificationsApiAvailable.value && !idValue.startsWith('local-')) {
				try {
					await api.patch(`${NOTIFICATIONS_ENDPOINT}/${id}/read`)
					notificationsListApi.value = notificationsListApi.value.filter(
						item => String(item.id) !== idValue,
					)
					if (typeof unreadCount.value === 'number') {
						unreadCount.value = Math.max(0, unreadCount.value - 1)
					}
				} catch (error) {
					console.warn(
						'[TeacherHeader] Failed to mark notification read:',
						error,
					)
				}
			}
			appStore.removeNotification(id)
		}
		const handleMessages = () => {
			emit('open-messages')
		}

		const handleNotifications = () => {
			notificationsOpen.value = !notificationsOpen.value
			if (notificationsOpen.value) {
				fetchNotifications()
			}
			emit('open-notifications')
		}

		const handleAvatarError = () => {
			avatarError.value = true
		}

		const handleLogoError = () => {
			console.warn('[Security] Logo failed to load')
		}

		const toggleDropdown = () => {
			isOpen.value = !isOpen.value
		}

		const closeDropdown = () => {
			isOpen.value = false
		}

		const handleLogout = async () => {
			if (isLoggingOut.value) return

			if (!logoutRateLimiter('logout')) {
				appStore.showWarning('Слишком много попыток. Повторите позднее')
				return
			}

			isLoggingOut.value = true

			try {
				closeDropdown()

				const { authService } = await import('@/services/auth')
				await authService.logout()

				appStore.clearUserData()
				appStore.showSuccess('Вы успешно вышли из системы')
				emit('logout')

				router.replace((localStorage.getItem('bitrix24_mode') === 'true' || (() => { try { return window.self !== window.top } catch (_) { return true } })()) ? '/bitrix24-auth' : '/auth')
			} catch (error) {
				if (process.env.NODE_ENV === 'development') {
					console.error('[TeacherHeader] Logout error:', error.message)
				}

				appStore.showError('Ошибка при выходе из системы')

				if (error.response?.status === 401) {
					appStore.clearUserData()
					router.replace((localStorage.getItem('bitrix24_mode') === 'true' || (() => { try { return window.self !== window.top } catch (_) { return true } })()) ? '/bitrix24-auth' : '/auth')
				}
			} finally {
				isLoggingOut.value = false
			}
		}

		const handleClickOutside = e => {
			if (!profileContainer.value?.contains(e.target)) {
				closeDropdown()
			}
			const isNotificationClick = notificationsContainer.value?.contains(
				e.target,
			)
			if (!isNotificationClick) {
				notificationsOpen.value = false
			}
		}

		const handleEscape = e => {
			if (e.key === 'Escape' && isOpen.value) {
				closeDropdown()
				dropdownTrigger.value?.focus()
			}
			if (e.key === 'Escape' && notificationsOpen.value) {
				notificationsOpen.value = false
			}
		}

		// Защита от clickjacking (актуально для Bitrix24)
		onMounted(() => {
			const isBitrix24Mode = localStorage.getItem('bitrix24_mode') === 'true'
			
			if (window.self !== window.top && !isBitrix24Mode) {
				console.warn('[Security] App loaded in iframe, redirecting to top')
				try {
					window.top.location = window.self.location
				} catch (e) {
					console.error('[Security] Cannot redirect to top:', e)
				}
			} else if (isBitrix24Mode) {
				console.log('[Security] Bitrix24 mode - iframe allowed')
			}

			loadSearchHistory()
			loadTeacherStats()
			startNotificationsPolling()
			notificationUnsubscribe = accountSocket.onNotification(payload => {
				addIncomingNotification(payload)
			})
			document.addEventListener('click', handleClickOutside)
			document.addEventListener('keydown', handleEscape)
		})

		onBeforeUnmount(() => {
			document.removeEventListener('click', handleClickOutside)
			document.removeEventListener('keydown', handleEscape)
			stopNotificationsPolling()
			if (notificationUnsubscribe) {
				notificationUnsubscribe()
				notificationUnsubscribe = null
			}
			searchQuery.value = ''
		})
		return {
			// Search
			searchQuery,
			searchFocused,
			showSearchDropdown,
			isSearching,
			searchResults,
			searchHistory,
			selectedIndex,
			searchContainer,
			searchInput,
			myCourseResults,
			studentResults,
			totalResults,
			teacherQuickAccess,
			isSearchValid,

			// Profile
			isOpen,
			isLoggingOut,
			profileContainer,
			dropdownTrigger,

			// Notifications
			notificationsOpen,
			notificationsContainer,
			notificationsLoading,
			notificationsError,
			notificationsList,

			// User data
			safeUserName,
			maskedEmail,
			safeAvatarUrl,
			safeLogoUrl,
			safeUserInitials,

			// Stats
			teacherStats,

			// Badges
			safeMessagesCount,
			safeNotificationsCount,
			messagesBadge,
			notificationsBadge,

			// Methods
			sanitizeText,
			highlightMatch,
			handleSearchFocus,
			handleSearchBlur,
			handleSearchInput,
			handleSearchKeydown,
			executeSearch,
			selectResult,
			selectFromHistory,
			navigateToQuickAccess,
			clearSearch,
			clearSearchHistory,
			showAllResults,
			handleMessages,
			handleNotifications,
			formatNotificationTime,
			clearNotifications,
			removeNotification,
			handleAvatarError,
			handleLogoError,
			toggleDropdown,
			closeDropdown,
			handleLogout,
		}
	},
}
</script>

<style scoped>
/* MODERN TEACHER HEADER DESIGN */
.th-header {
	/* Важно: z-index должен быть выше чем у автодополняющих элементов.
	   По умолчанию у hero-секций dropdown может оказаться "под" элементами. */
	position: relative;
	top: 0;
	z-index: 10000;
	background-color: rgba(0, 149, 236, 0.1);
	border-bottom: 1px solid rgba(0, 149, 236, 0.1);
	height: 72px;
}

.th-container {
	max-width: 1400px;
	margin: 0 auto;
	padding: 0 24px;
	height: 100%;
	display: flex;
	align-items: center;
	gap: 32px;
}

/* LOGO */
.th-logo {
	position: relative;
	width: 99px;
	height: 54px;
	flex-shrink: 0;
}

.th-logo-text {
	position: absolute;
	left: 47px;
	top: 45px;
	width: 48px;
	height: 9px;
	color: #636363;
	font-family: 'Prosto One', Helvetica, sans-serif;
	font-size: 7px;
	font-weight: 400;
}

.th-logo-image {
	position: absolute;
	left: 0;
	top: 0;
	width: 97px;
	height: 48px;
}

/* NAVIGATION */
.th-nav {
	display: flex;
	gap: 12px;
	flex: 1;
	transform: translateX(200px);
}

.th-notifications {
	position: relative;
	display: inline-flex;
}

.th-notifications-dropdown {
	position: absolute;
	top: calc(100% + 12px);
	right: 0;
	min-width: 280px;
	max-width: 360px;
	background: #fff;
	border: 1px solid rgba(0, 0, 0, 0.08);
	border-radius: 14px;
	box-shadow: 0 16px 32px rgba(15, 23, 42, 0.14);
	padding: 12px;
	z-index: 10001;
}

.th-notifications-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	font-weight: 600;
	font-size: 14px;
	color: #1f2937;
	margin-bottom: 10px;
}

.th-notifications-clear {
	border: none;
	background: transparent;
	color: #2563eb;
	font-size: 12px;
	cursor: pointer;
}

.th-notifications-clear:hover {
	text-decoration: underline;
}

.th-notifications-empty {
	font-size: 12px;
	color: #6b7280;
	padding: 8px 0;
}

.th-notifications-list {
	list-style: none;
	margin: 0;
	padding: 0;
	display: flex;
	flex-direction: column;
	gap: 10px;
	max-height: 320px;
	overflow-y: auto;
}

.th-notifications-item {
	border: 1px solid rgba(15, 23, 42, 0.08);
	border-radius: 12px;
	padding: 10px 12px;
	background: #f8fafc;
	position: relative;
	padding-right: 34px;
}

.th-notifications-item-title {
	font-size: 13px;
	font-weight: 600;
	color: #111827;
	margin-bottom: 4px;
}

.th-notifications-item-text {
	font-size: 12px;
	color: #4b5563;
	margin-bottom: 6px;
}

.th-notifications-item-time {
	font-size: 11px;
	color: #9ca3af;
}

.th-notifications-close {
	position: absolute;
	top: 8px;
	right: 8px;
	width: 20px;
	height: 20px;
	padding: 0;
	border: none;
	border-radius: 6px;
	background: transparent;
	color: #94a3b8;
	cursor: pointer;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	transition: color 0.2s ease, background 0.2s ease;
}

.th-notifications-close:hover {
	color: #1f2937;
	background: rgba(15, 23, 42, 0.06);
}

.th-notifications-close svg {
	width: 14px;
	height: 14px;
}
.th-nav-link,
.th-nav-btn {
	position: relative;
	padding: 8px 16px;
	border-radius: 12px;
	text-decoration: none;
	color: #64748b;
	transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
	overflow: hidden;
	background: transparent;
	border: none;
	cursor: pointer;
	font-family: inherit;
}

.th-nav-link-content,
.th-nav-btn-content {
	display: flex;
	align-items: center;
	gap: 10px;
	position: relative;
	z-index: 2;
}

.th-nav-icon-wrapper {
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 32px;
	height: 32px;
	border-radius: 10px;
	background: rgba(0, 149, 236, 0.1);
	transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.th-nav-icon {
	width: 20px;
	height: 20px;
	transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
	color: #0095ec;
}

.th-nav-label {
	font-weight: 500;
	font-size: 14px;
	letter-spacing: 0.2px;
}

.th-nav-link-indicator {
	position: absolute;
	bottom: 0;
	left: 50%;
	transform: translateX(-50%) scaleX(0);
	width: 24px;
	height: 3px;
	background: linear-gradient(90deg, #0095ec 0%, #0085d4 100%);
	border-radius: 3px 3px 0 0;
	transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.th-nav-link:hover,
.th-nav-btn:hover {
	color: #475569;
	background: rgba(0, 149, 236, 0.08);
}

.th-nav-link:hover .th-nav-icon-wrapper,
.th-nav-btn:hover .th-nav-icon-wrapper {
	background: rgba(0, 149, 236, 0.15);
	transform: scale(1.05);
}

.th-nav-link.router-link-active {
	color: #0095ec;
	background: linear-gradient(
		135deg,
		rgba(0, 149, 236, 0.08) 0%,
		rgba(0, 133, 212, 0.08) 100%
	);
}

.th-nav-link.router-link-active .th-nav-icon-wrapper {
	background: linear-gradient(135deg, #0095ec 0%, #0085d4 100%);
}

.th-nav-link.router-link-active .th-nav-icon {
	color: white;
}

.th-nav-link.router-link-active .th-nav-link-indicator {
	transform: translateX(-50%) scaleX(1);
}

.th-nav-btn--active {
	color: #0095ec;
}

.th-nav-btn--active .th-nav-icon-wrapper {
	background: rgba(0, 149, 236, 0.15);
}

/* BADGES */
.th-nav-icon-wrapper .th-badge {
	position: absolute;
	top: -4px;
	right: -4px;
	min-width: 18px;
	height: 18px;
	padding: 0 5px;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 10px;
	font-weight: 700;
	border-radius: 9px;
	color: white;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.th-badge--primary {
	background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
}

.th-badge--danger {
	background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
}

.badge-pop-enter-active {
	animation: badgePop 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

@keyframes badgePop {
	0% {
		transform: scale(0);
	}
	50% {
		transform: scale(1.2);
	}
	100% {
		transform: scale(1);
	}
}

.th-nav-btn--active .th-nav-icon {
	animation: wiggle 2s ease-in-out infinite;
}

@keyframes wiggle {
	0%,
	100% {
		transform: rotate(0deg);
	}
	25% {
		transform: rotate(-5deg);
	}
	75% {
		transform: rotate(5deg);
	}
}

/* DIVIDER */
.th-divider {
	width: 1px;
	height: 32px;
	background: linear-gradient(
		180deg,
		transparent,
		rgba(0, 149, 236, 0.2),
		transparent
	);
	flex-shrink: 0;
}

/* ACTIONS */
.th-actions {
	display: flex;
	align-items: center;
	gap: 16px;
	flex-shrink: 0;
}

/* SEARCH */
.th-search {
	position: relative;
	width: 240px;
}

.th-search--active {
	width: 280px;
}

.th-search-field {
	position: relative;
	display: flex;
	align-items: center;
}

.th-search-input {
	width: 100%;
	height: 40px;
	padding: 0 80px 0 16px;
	background: #f8fafc;
	border: 2px solid transparent;
	border-radius: 20px;
	font-size: 14px;
	font-family: 'Inter', -apple-system, sans-serif;
	color: #334155;
	transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
	outline: none;
}

.th-search-input::placeholder {
	color: #94a3b8;
}

.th-search-input:focus {
	background: white;
	border-color: #0095ec;
	box-shadow: 0 0 0 3px rgba(0, 149, 236, 0.1);
}

.th-search-clear {
	position: absolute;
	right: 40px;
	width: 24px;
	height: 24px;
	display: flex;
	align-items: center;
	justify-content: center;
	background: transparent;
	border: none;
	color: #94a3b8;
	cursor: pointer;
	border-radius: 50%;
	transition: all 0.2s;
}

.th-search-clear:hover {
	background: rgba(148, 163, 184, 0.1);
	color: #64748b;
}

.th-search-btn {
	position: absolute;
	right: 4px;
	width: 32px;
	height: 32px;
	display: flex;
	align-items: center;
	justify-content: center;
	background: transparent;
	border: none;
	border-radius: 50%;
	color: #94a3b8;
	cursor: pointer;
	transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.th-search-btn svg {
	width: 18px;
	height: 18px;
}

.th-search-btn:hover:not(:disabled) {
	background: rgba(0, 149, 236, 0.1);
	color: #0095ec;
}

.th-search-btn:disabled {
	opacity: 0.5;
	cursor: not-allowed;
}

.th-search-btn--active {
	color: #0095ec;
}

.th-search-spinner svg {
	animation: spin 1s linear infinite;
}

@keyframes spin {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(360deg);
	}
}

/* SEARCH DROPDOWN */
.th-search-dropdown {
	position: absolute;
	top: calc(100% + 8px);
	left: 0;
	right: 0;
	background: white;
	border: 1px solid rgba(0, 149, 236, 0.15);
	border-radius: 16px;
	box-shadow: 0 10px 40px rgba(0, 149, 236, 0.12);
	max-height: 480px;
	overflow-y: auto;
	z-index: 10001;
}

.th-search-section-title {
	font-size: 12px;
	font-weight: 600;
	color: #64748b;
	text-transform: uppercase;
	letter-spacing: 0.5px;
	padding: 12px 16px 8px;
}

.th-search-section-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 12px 16px 8px;
}

.th-search-clear-history {
	font-size: 12px;
	color: #94a3b8;
	background: none;
	border: none;
	cursor: pointer;
	transition: color 0.2s;
}

.th-search-clear-history:hover {
	color: #0095ec;
}

.th-search-tags {
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
	padding: 0 16px 12px;
}

.th-search-tag {
	display: inline-flex;
	align-items: center;
	gap: 6px;
	padding: 6px 12px;
	background: #f1f5f9;
	border: 1px solid transparent;
	border-radius: 20px;
	font-size: 13px;
	color: #475569;
	cursor: pointer;
	transition: all 0.2s;
}

.th-search-tag:hover {
	background: white;
	border-color: #0095ec;
	color: #0095ec;
}

.th-search-tag-icon {
	width: 14px;
	height: 14px;
}

.th-search-history-item {
	display: flex;
	align-items: center;
	gap: 12px;
	padding: 10px 16px;
	width: 100%;
	background: none;
	border: none;
	text-align: left;
	cursor: pointer;
	transition: background 0.2s;
}

.th-search-history-item:hover {
	background: rgba(0, 149, 236, 0.08);
}

.th-search-history-item svg {
	color: #94a3b8;
}

.th-search-history-item span {
	flex: 1;
	font-size: 14px;
	color: #334155;
}

/* Search Results */
.th-search-category {
	border-bottom: 1px solid rgba(0, 149, 236, 0.1);
	padding-bottom: 8px;
	margin-bottom: 8px;
}

.th-search-category:last-child {
	border-bottom: none;
	margin-bottom: 0;
}

.th-search-category-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 8px 16px;
}

.th-search-category-title {
	font-size: 12px;
	font-weight: 600;
	color: #64748b;
	text-transform: uppercase;
	letter-spacing: 0.5px;
}

.th-search-category-count {
	font-size: 12px;
	padding: 2px 8px;
	background: #f1f5f9;
	border-radius: 10px;
	color: #64748b;
}

.th-search-result {
	display: flex;
	align-items: center;
	gap: 12px;
	padding: 10px 16px;
	text-decoration: none;
	color: #334155;
	transition: all 0.2s;
}

.th-search-result:hover {
	background: linear-gradient(
		90deg,
		rgba(0, 149, 236, 0.08) 0%,
		rgba(0, 133, 212, 0.08) 100%
	);
}

.th-search-result-icon {
	width: 32px;
	height: 32px;
	display: flex;
	align-items: center;
	justify-content: center;
	background: #f1f5f9;
	border-radius: 8px;
}

.th-search-result-icon--course {
	color: #0095ec;
}

.th-search-result-icon--student {
	color: #10b981;
}

.th-search-result-content {
	flex: 1;
	min-width: 0;
}

.th-search-result-title {
	font-size: 14px;
	font-weight: 500;
	color: #1e293b;
	margin-bottom: 2px;
}

.th-search-result-title mark {
	background: rgba(0, 149, 236, 0.2);
	color: inherit;
	padding: 0 2px;
	border-radius: 2px;
}

.th-search-result-meta {
	font-size: 12px;
	color: #94a3b8;
}

.th-search-result-badge {
	padding: 2px 6px;
	font-size: 10px;
	font-weight: 700;
	border-radius: 4px;
}

.th-search-result-badge--draft {
	background: #fbbf24;
	color: #92400e;
}

.th-search-show-all {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
	padding: 12px;
	width: 100%;
	background: #f8fafc;
	border: none;
	color: #0095ec;
	font-size: 14px;
	font-weight: 500;
	cursor: pointer;
	transition: background 0.2s;
}

.th-search-show-all:hover {
	background: #f1f5f9;
}

.th-search-loading {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 32px;
	gap: 12px;
	color: #94a3b8;
}

.th-search-loading-spinner {
	width: 24px;
	height: 24px;
	border: 2px solid rgba(0, 149, 236, 0.2);
	border-top-color: #0095ec;
	border-radius: 50%;
	animation: spin 0.8s linear infinite;
}

.th-search-empty {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 32px 16px;
	text-align: center;
}

.th-search-empty svg {
	color: #cbd5e1;
	margin-bottom: 16px;
}

.th-search-empty-title {
	font-size: 16px;
	font-weight: 600;
	color: #334155;
	margin-bottom: 4px;
}

.th-search-empty-text {
	font-size: 14px;
	color: #94a3b8;
}

/* Search Dropdown Animation */
.search-dropdown-enter-active,
.search-dropdown-leave-active {
	transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.search-dropdown-enter-from,
.search-dropdown-leave-to {
	opacity: 0;
	transform: translateY(-10px);
}

/* PROFILE */
.th-profile {
	position: relative;
	transform: translateX(100px);
}

.th-profile-btn {
	display: flex;
	align-items: center;
	gap: 12px;
	padding: 6px 12px 6px 6px;
	background: linear-gradient(
		135deg,
		rgba(241, 245, 249, 0.8) 0%,
		rgba(226, 232, 240, 0.8) 100%
	);
	border: 1px solid rgba(0, 149, 236, 0.2);
	border-radius: 50px;
	cursor: pointer;
	transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.th-profile-btn:hover {
	background: white;
	border-color: rgba(0, 149, 236, 0.3);
	box-shadow: 0 4px 12px rgba(0, 149, 236, 0.08);
	transform: translateY(-1px);
}

.th-profile-avatar {
	position: relative;
	width: 36px;
	height: 36px;
	border-radius: 50%;
	overflow: visible;
	background: linear-gradient(135deg, #0095ec 0%, #0085d4 100%);
}

.th-profile-avatar-clip {
	width: 100%;
	height: 100%;
	border-radius: 50%;
	overflow: hidden; /* Чтобы скрыть выходящие/переполняющие */
}

.th-profile-avatar-img {
	width: 100%;
	height: 100%;
	object-fit: cover;
}

.th-profile-avatar-placeholder {
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	color: white;
	font-weight: 600;
	font-size: 14px;
}

.th-profile-status {
	position: absolute;
	bottom: -1px;
	right: -1px;
	width: 10px;
	height: 10px;
	border: 2px solid white;
	border-radius: 50%;
	z-index: 10;
}

.th-profile-status--online {
	background: #10b981;
	animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
	0%,
	100% {
		transform: scale(1);
		opacity: 1;
	}
	50% {
		transform: scale(1.1);
		opacity: 0.8;
	}
}

.th-profile-info {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
}

.th-profile-name {
	font-size: 14px;
	font-weight: 600;
	color: #1e293b;
	line-height: 1.2;
}

.th-profile-role {
	display: flex;
	align-items: center;
	gap: 4px;
	font-size: 12px;
	color: #0095ec;
	line-height: 1.2;
	font-weight: 500;
}

.th-profile-role-icon {
	width: 14px;
	height: 14px;
}

.th-profile-arrow {
	width: 20px;
	height: 20px;
	color: #64748b;
	transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.th-profile-arrow--open {
	transform: rotate(180deg);
}

/* DROPDOWN */
.th-dropdown {
	position: absolute;
	top: calc(100% + 8px);
	right: 0;
	width: 280px;
	background: white;
	border: 1px solid rgba(0, 149, 236, 0.15);
	border-radius: 16px;
	box-shadow: 0 10px 40px rgba(0, 149, 236, 0.12);
	overflow: hidden;
	z-index: 10001;
}

.th-dropdown-header {
	display: flex;
	align-items: center;
	gap: 12px;
	padding: 16px;
	background: linear-gradient(
		135deg,
		rgba(0, 149, 236, 0.05) 0%,
		rgba(0, 133, 212, 0.05) 100%
	);
}

.th-dropdown-avatar {
	width: 48px;
	height: 48px;
	border-radius: 50%;
	overflow: hidden;
	background: linear-gradient(135deg, #0095ec 0%, #0085d4 100%);
	flex-shrink: 0;
}

.th-dropdown-avatar img {
	width: 100%;
	height: 100%;
	object-fit: cover;
}

.th-dropdown-avatar-placeholder {
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	color: white;
	font-weight: 600;
	font-size: 18px;
}

.th-dropdown-user {
	flex: 1;
	min-width: 0;
}

.th-dropdown-username {
	font-weight: 600;
	font-size: 14px;
	color: #1e293b;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.th-dropdown-email {
	font-size: 12px;
	color: #64748b;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	user-select: none;
}

.th-dropdown-divider {
	height: 1px;
	background: rgba(0, 149, 236, 0.15);
	margin: 0;
}

.th-dropdown-item {
	display: flex;
	align-items: center;
	gap: 12px;
	padding: 12px 16px;
	color: #475569;
	text-decoration: none;
	font-size: 14px;
	font-weight: 500;
	background: transparent;
	border: none;
	width: 100%;
	text-align: left;
	cursor: pointer;
	transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
	position: relative;
}

.th-dropdown-item:hover {
	background: rgba(0, 149, 236, 0.08);
	color: #1e293b;
	padding-left: 20px;
}

.th-dropdown-item--danger {
	color: #dc2626;
}

.th-dropdown-item--danger:hover {
	background: rgba(239, 68, 68, 0.08);
	color: #b91c1c;
}

.th-dropdown-icon {
	width: 20px;
	height: 20px;
	flex-shrink: 0;
}

.th-dropdown-item span {
	flex: 1;
}

.th-dropdown-badge {
	margin-left: auto;
	padding: 2px 8px;
	background: linear-gradient(135deg, #0095ec 0%, #0085d4 100%);
	color: white;
	font-size: 11px;
	font-weight: 600;
	border-radius: 10px;
}

/* Dropdown Animation */
.th-dropdown-enter-active,
.th-dropdown-leave-active {
	transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.th-dropdown-enter-from,
.th-dropdown-leave-to {
	opacity: 0;
	transform: translateY(-10px) scale(0.95);
}

/* RESPONSIVE */
@media (max-width: 1200px) {
	.th-container {
		padding: 0 16px;
		gap: 20px;
	}

	.th-search {
		width: 200px;
	}

	.th-search--active {
		width: 240px;
	}
}

@media (max-width: 992px) {
	.th-nav {
		gap: 8px;
	}

	.th-nav-label {
		display: none;
	}

	.th-search {
		width: 180px;
	}
}

@media (max-width: 768px) {
	.th-header {
		height: 64px;
	}

	.th-profile-info {
		display: none;
	}

	.th-divider {
		display: none;
	}

	.th-actions {
		gap: 8px;
	}

	.th-search-dropdown {
		position: fixed;
		left: 16px;
		right: 16px;
		top: 80px;
	}
}

@media (max-width: 576px) {
	.th-container {
		padding: 0 12px;
		gap: 12px;
	}

	.th-logo-wrapper {
		padding: 6px 10px;
	}

	.th-nav {
		gap: 4px;
	}

	.th-nav-link,
	.th-nav-btn {
		padding: 8px;
	}

	.th-search {
		display: none;
	}

	.th-dropdown {
		width: 260px;
		right: -8px;
	}
}

/* Security styles */
.th-profile-avatar-img,
.th-dropdown-avatar img {
	max-width: 100%;
	max-height: 100%;
	object-fit: cover;
	contain: layout style paint;
}

.th-search-input {
	word-break: break-all;
	overflow: hidden;
	text-overflow: ellipsis;
}

.th-dropdown {
	contain: layout style;
	max-height: calc(100vh - 100px);
	overflow-y: auto;
}

.th-header {
	opacity: 1 !important;
	pointer-events: auto !important;
}
</style>

